










































































/* General */
import Vue from 'vue'
import isEqual from 'lodash/isEqual'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IItemForSelection, INameAndValue } from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'IfpFilterTags',

  props: {
    selectedIncludingTagIds: {
      type: Array as () => number[],
      required: true,
    },
    selectedExcludingTagIds: {
      type: Array as () => number[],
      required: true,
    },
    tagOptions: {
      type: Array as () => IItemForSelection[],
      required: true,
    },
  },

  data() {
    return {
      exposedTab: 'included',
      /**
       * TABS
       */
      tabs: [
        {
          name: 'included',
          value: 'Include',
        },
        {
          name: 'excluded',
          value: 'Don’t Include',
        },
      ] as INameAndValue[],
    }
  },

  computed: {
    isIncludedTabExposed(): boolean {
      return this.exposedTab === 'included'
    },

    isExcludedTabExposed(): boolean {
      return this.exposedTab === 'excluded'
    },

    internalSelectedIncludingTagIDs: {
      get(): string[] {
        return this.tagOptions
          .filter(tag => this.selectedIncludingTagIds.includes(tag.id))
          .map(tag => tag.name)
      },
      set(newValue: string[]) {
        const newSelectedTagIds = this.tagOptions
          .filter(tag => newValue.includes(tag.name))
          .map(tag => tag.id)

        if (!isEqual(newSelectedTagIds, this.selectedIncludingTagIds)) {
          this.$emit('selected-including-tag-ids-updated', newSelectedTagIds)
        }
      },
    },

    internalSelectedExcludingTagIDs: {
      get(): string[] {
        return this.tagOptions
          .filter(tag => this.selectedExcludingTagIds.includes(tag.id))
          .map(tag => tag.name)
      },
      set(newValue: string[]) {
        const newSelectedTagIds = this.tagOptions
          .filter(tag => newValue.includes(tag.name))
          .map(tag => tag.id)

        if (!isEqual(newSelectedTagIds, this.selectedExcludingTagIds)) {
          this.$emit('selected-excluding-tag-ids-updated', newSelectedTagIds)
        }
      },
    },

    availableTagsToDisplay(): string[] {
      if (this.isIncludedTabExposed) {
        return this.tagOptions
          .filter(tag => !this.selectedExcludingTagIds.includes(tag.id))
          .map(tag => tag.name)
      } else {
        return this.tagOptions
          .filter(tag => !this.selectedIncludingTagIds.includes(tag.id))
          .map(tag => tag.name)
      }
    },

    numberSelectedTags(): number {
      return (
        this.internalSelectedIncludingTagIDs.length +
        this.internalSelectedExcludingTagIDs.length
      )
    },

    numberSelectedTagsDisplay(): string {
      return this.numberSelectedTags === 1
        ? this.numberSelectedTags + ' Tag'
        : this.numberSelectedTags + ' Tags'
    },

    hasSelectedTags(): boolean {
      return this.numberSelectedTags > 0
    },

    selectedTagsExposed(): string[] {
      if (this.isIncludedTabExposed) {
        return this.internalSelectedIncludingTagIDs
      } else {
        return this.internalSelectedExcludingTagIDs
      }
    },
  },

  methods: {
    removeTag(tag: string) {
      if (this.isIncludedTabExposed) {
        this.internalSelectedIncludingTagIDs = this.internalSelectedIncludingTagIDs.filter(
          t => t !== tag,
        )
      } else {
        this.internalSelectedExcludingTagIDs = this.internalSelectedExcludingTagIDs.filter(
          t => t !== tag,
        )
      }
    },

    clearAllTags() {
      this.$emit('selected-including-tag-ids-updated', [])
      this.$emit('selected-excluding-tag-ids-updated', [])
    },

    handleClearClick() {
      this.clearAllTags()
    },

    exposeTab(val: string) {
      this.exposedTab = val
    },
  },
})
